<template>
    <div class="ma-0 pa-0" style="width: 100%;">

        <!-- ══════════════ Layout MOBILE: due righe fisse, mai spezzate ══════════════ -->
        <template v-if="dense">
            <div class="d-flex align-center riga-mobile">
                <v-btn-toggle v-model="localVista" mandatory dense class="rounded-lg toggle-compatta mr-1">
                    <v-btn value="month" icon x-small v-tooltip.bottom="'Vista mensile'">
                        <v-icon small>calendar_view_month</v-icon>
                    </v-btn>
                    <v-btn value="week" icon x-small v-tooltip.bottom="'Vista settimanale'">
                        <v-icon small>calendar_view_week</v-icon>
                    </v-btn>
                    <v-btn value="day" icon x-small v-tooltip.bottom="'Vista giornaliera'">
                        <v-icon small>calendar_view_day</v-icon>
                    </v-btn>
                    <v-btn value="agenda" icon x-small v-tooltip.bottom="'Programma'">
                        <v-icon small>view_agenda</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <v-btn text icon x-small @click="$emit('prev')" v-tooltip.bottom="'Precedente'">
                    <v-icon small>keyboard_arrow_left</v-icon>
                </v-btn>

                <v-btn text x-small @click="$emit('oggi')" class="px-1 periodo-mobile">
                    {{ periodoCorrente }}
                </v-btn>

                <v-btn text icon x-small @click="$emit('next')" v-tooltip.bottom="'Successivo'">
                    <v-icon small>keyboard_arrow_right</v-icon>
                </v-btn>
            </div>

            <div class="d-flex align-center riga-mobile mt-2">
                <v-text-field v-model="localSearch" append-icon="search" label="Cerca" hide-details clearable dense
                    class="mr-1 campo-cerca-mobile" />

                <v-chip class="mr-1 flex-shrink-0">
                    Totale: {{ totaleOreLavoro }}
                </v-chip>

                <menu-altre-azioni class="flex-shrink-0" :role="role" :filtri-utenti="filtriUtenti"
                    :filtro-utente-sel.sync="localFiltroUtenteSel" :mostra-ore.sync="localMostraOre"
                    :mostra-task.sync="localMostraTask" :mostra-completate.sync="localMostraCompletate"
                    :mostra-promemoria.sync="localMostraPromemoria" @refresh="$emit('refresh')"
                    @esportaExcel="$emit('esportaExcel')" />
            </div>
        </template>

        <!-- ══════════════ Layout DESKTOP: riga singola, può andare a capo per gruppi ══════════════ -->
        <template v-else>
            <v-row class="d-flex align-center flex-wrap ma-0 pa-0">

                <!-- Selezione vista calendario -->
                <v-btn-toggle v-model="localVista" mandatory class="rounded-lg my-toggle mr-2 mt-2">
                    <v-btn value="month" icon v-tooltip.bottom="'Vista mensile'">
                        <v-icon>calendar_view_month</v-icon>
                    </v-btn>
                    <v-btn value="week" icon v-tooltip.bottom="'Vista settimanale'">
                        <v-icon>calendar_view_week</v-icon>
                    </v-btn>
                    <v-btn value="day" icon v-tooltip.bottom="'Vista giornaliera'">
                        <v-icon>calendar_view_day</v-icon>
                    </v-btn>
                    <v-btn value="agenda" icon v-tooltip.bottom="'Programma'">
                        <v-icon>view_agenda</v-icon>
                    </v-btn>
                </v-btn-toggle>

                <!-- Navigazione mese/periodo: raggruppata così va a capo tutta insieme, mai spezzata -->
                <div class="d-flex align-center flex-shrink-0 mt-2">
                    <v-btn text icon @click="$emit('prev')" v-tooltip.bottom="'Precedente'">
                        <v-icon>keyboard_arrow_left</v-icon>
                    </v-btn>

                    <v-btn class="pl-0 pr-0" text small @click="$emit('oggi')"
                        style="min-width: 90px; text-align: center; font-weight:600;">
                        {{ periodoCorrente }}
                    </v-btn>

                    <v-btn text icon @click="$emit('next')" v-tooltip.bottom="'Successivo'">
                        <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                </div>

                <!-- Cerca -->
                <v-text-field v-model="localSearch" append-icon="search" label="Cerca" hide-details clearable
                    class="ml-2 pb-1 mt-2" style="max-width: 220px;" />

                <v-spacer />

                <v-chip class="mr-2 mt-2 pt-0">
                    Totale ore: {{ totaleOreLavoro }}
                </v-chip>

                <!-- Nuovo: ore o attività -->
                <v-btn color=primary @click="$emit('apriDialog')" class="mr-2">
                    <v-icon small color="secondary">add</v-icon>
                    Ore
                </v-btn>
                <v-btn color="tertiary" @click="$emit('apriDialogTask')">
                    <v-icon small color="secondary">add</v-icon>
                    attività
                </v-btn>

                <menu-altre-azioni class="mt-2 ml-1" :role="role" :filtri-utenti="filtriUtenti"
                    :filtro-utente-sel.sync="localFiltroUtenteSel" :mostra-ore.sync="localMostraOre"
                    :mostra-task.sync="localMostraTask" :mostra-completate.sync="localMostraCompletate"
                    :mostra-promemoria.sync="localMostraPromemoria" @refresh="$emit('refresh')"
                    @esportaExcel="$emit('esportaExcel')" />
            </v-row>

            <!-- Legenda colori -->
            <v-row class="ma-0 pa-0 mt-1" style="row-gap: 2px;">
                <span v-for="voce in legenda" :key="voce.label" class="legenda-voce">
                    <span class="legenda-pallino" :style="{ backgroundColor: voce.colore }" />
                    {{ voce.label }}
                </span>
            </v-row>
        </template>
    </div>
</template>

<script>
import MenuAltreAzioni from './MenuAltreAzioni.vue';

export default {
    components: { MenuAltreAzioni },

    props: {
        today: String,
        role: String,
        vista: { type: String, default: 'month' },
        filtroUtenteSel: String,
        filtriUtenti: Array,
        mostraCompletate: Boolean,
        mostraPromemoria: { type: Boolean, default: true },
        mostraOre: { type: Boolean, default: true },
        mostraTask: { type: Boolean, default: true },
        search: String,
        dense: Boolean,
        totaleOreLavoro: String,
    },

    data: () => ({
        legenda: [
            { label: 'Lavoro', colore: 'var(--primary)' },
            { label: 'Ferie / permesso', colore: '#F9A825' },
            { label: 'Attività', colore: '#8BC34A' },
            { label: 'Appuntamento', colore: '#F9A825' },
            { label: 'Riunione', colore: '#FF5722' },
            { label: 'Note', colore: '#009688' },
        ],
    }),

    computed: {
        periodoCorrente() {
            const d = new Date(this.today + 'T00:00:00');
            if (this.vista === 'month' || this.vista === 'agenda') {
                return d.toLocaleString('it', { month: 'long', year: 'numeric' });
            }
            if (this.vista === 'week') {
                // Inizio settimana (lunedì)
                const day = d.getDay() || 7;
                const lunedi = new Date(d);
                lunedi.setDate(d.getDate() - day + 1);
                const domenica = new Date(lunedi);
                domenica.setDate(lunedi.getDate() + 6);
                return `${lunedi.getDate()}/${lunedi.getMonth() + 1} - ${domenica.getDate()}/${domenica.getMonth() + 1}`;
            }
            if (this.vista === 'day') {
                return d.toLocaleDateString('it', { weekday: 'short', day: 'numeric', month: 'short' });
            }
            return '';
        },

        localVista: {
            get() { return this.vista; },
            set(v) { this.$emit('update:vista', v); },
        },
        localFiltroUtenteSel: {
            get() { return this.filtroUtenteSel; },
            set(v) { this.$emit('update:filtroUtenteSel', v); },
        },
        localMostraCompletate: {
            get() { return this.mostraCompletate; },
            set(v) { this.$emit('update:mostraCompletate', v); },
        },
        localMostraPromemoria: {
            get() { return this.mostraPromemoria; },
            set(v) { this.$emit('update:mostraPromemoria', v); },
        },
        localMostraOre: {
            get() { return this.mostraOre; },
            set(v) { this.$emit('update:mostraOre', v); },
        },
        localMostraTask: {
            get() { return this.mostraTask; },
            set(v) { this.$emit('update:mostraTask', v); },
        },
        localSearch: {
            get() { return this.search; },
            set(v) { this.$emit('update:search', v); },
        },
    },
};
</script>

<style scoped>
.riga-mobile {
    flex-wrap: nowrap;
    width: 100%;
}

.toggle-compatta ::v-deep .v-btn {
    min-width: 26px !important;
    width: 34px !important;
    height: 36px !important;
}

.periodo-mobile {
    font-size: 14px !important;
    font-weight: 600;
    min-width: 0 !important;
    white-space: nowrap;
}

.campo-cerca-mobile {
    flex: 1 1 auto;
    min-width: 0;
}

.legenda-voce {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-right: 12px;
}

.theme--dark .legenda-voce {
    color: rgba(255, 255, 255, 0.7);
}

.legenda-pallino {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
</style>
